export const BUSINESS_TYPE = {
  STANDARD: 1,
  AREA: 2,
  HYBRID: 3
};
